module.exports = __webpack_public_path__ + "src/images/body_model_green.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/body_model_green.svg
// module id = 1131
// module chunks = 0